export enum DisplayMode {
  CONTENT_TILE = "content-tile",
  MAP = "map",
  SCREEN_FOCUS = "screen-focus",
  SPEAKER = "speaker",
  TILE = "tile",
}
